import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Sidebar, Header, Footer } from '../../organisms';
import { TaxonomyProvider } from '../../../contexts/TaxonomyContext';

const AppShell = ({
  children,
  primaryPages = [],
  locales = [],
  footerPages = {},
  componentProps = {},
  taxonomyGroups = [],
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const hasSidebar = componentProps?.layoutConfig?.hasSidebar;
  const sidebarData = componentProps?.sidebar;
  const currentLocale = componentProps?.currentLocale || null;

  const { columns: footerColumns = [], copyright = '' } = footerPages || {};
  console.log('FOOTER DEBUG:', { footerPages, footerColumns, copyright });
  return (
    <TaxonomyProvider groups={taxonomyGroups}>
      <div className="app">
        <header className="site-header">
          <Header
            primaryPages={primaryPages}
            locales={locales}
            currentLocale={currentLocale}
          />
        </header>
        <div className="main-shell">
          {hasSidebar && sidebarData && (
            <aside className={`site-sidebar transition-all duration-300 ${sidebarCollapsed ? 'w-sidebar-collapsed' : 'w-sidebar'}`}>
              <Sidebar
                {...sidebarData}
                isCollapsed={sidebarCollapsed}
                onToggleCollapse={() => setSidebarCollapsed(v => !v)}
              />
            </aside>
          )}
          <main className="site-content">
            <div className="page">
              {children}
            </div>
          </main>
        </div>
        <footer className="site-footer">
          <Footer footerPages={footerColumns} copyright={copyright} />
        </footer>
      </div>
    </TaxonomyProvider>
  );
};

AppShell.propTypes = {
  children:       PropTypes.node,
  primaryPages:   PropTypes.array,
  locales:        PropTypes.array,
  footerPages:    PropTypes.object,
  componentProps: PropTypes.object,
  taxonomyGroups: PropTypes.array,
};

export default AppShell;